import { useLocation } from 'react-router-dom';

import { WORKLOAD_CATEGORIES } from '../_constants';
import { getWorkloadsCategoryFromPathname } from '../_utils';
import { InventoryWorkloadsCurrentDate } from './InventoryWorkloadsCurrentDate';
import { InventoryWorkloadsRangePicker } from './InventoryWorkloadsRangePicker';

export const InventoryWorkloadsListDateControl = () => {
  const { pathname } = useLocation();
  const category = getWorkloadsCategoryFromPathname(pathname);

  if (
    category === WORKLOAD_CATEGORIES.AUTOSCALING ||
    category === WORKLOAD_CATEGORIES.SAVINGS
  ) {
    return <InventoryWorkloadsCurrentDate />;
  }

  return <InventoryWorkloadsRangePicker />;
};
